import React from "react";
import { SidebarIcons } from "../../StandardContentSidebar/SidebarIcons";


const mailmenu = [
  {
    id: 16,
    uri: `mail/email-lists`,
    label: "Mail",
    type: "nav-item",
    icon: SidebarIcons.EmailIcon,
    color: "#4B4B4B",
  },
];

export default mailmenu;
